import { React, useEffect, useState } from "react";
import AvatarTooltip from "./AvatarTooltip";
import NavigationBar from "./NavigationBar";

import { useUser } from "./../../context/UserContext";

const TopBarSignedIn = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const { user, loginUser } = useUser(); // Use context

  useEffect(() => {

  }, []);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  return (
    <header className="flex flex-wrap gap-6 items-center px-6 w-full text-sm leading-loose text-gray-700 bg-gray-100 max-md:px-5 max-md:max-w-full">

      {/* Left section - Logo */}
      {/* <div className="flex items-center">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/1b4e8b67bf55f37b945825a4c996f3a5708f57d70bce85025e4e12468702b119?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
          alt="Logo"
          className="object-contain shrink-0 aspect-[1.11] w-[41px]"
        />
      </div> */}

      {/* Center section - Navigation */}
      <div className="flex-1 flex justify-center">
        <NavigationBar activeItem="donate" />
      </div>

      {/* Right section - Notifications and Profile */}
      <div className="flex items-center gap-6">
        <button
          aria-label="Notifications"
          className="flex shrink-0 w-6 h-6"
        />
        <div className="flex gap-2 items-center relative">
          <button
            onClick={toggleTooltip}
            className="flex items-center gap-2 focus:outline-none"
            aria-label="User menu"
            aria-expanded={showTooltip}
          >
            {user && <img
              src={user && user.avatar}
              alt="User profile"
              className="object-contain shrink-0 w-8 aspect-square rounded-[400px]"
            />}
            <span>{user && user.name}</span>
          </button>

          {showTooltip && (
            <AvatarTooltip
              onClose={() => setShowTooltip(false)}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default TopBarSignedIn;
